const homeportDups = (values) => {
  const homeports = values.trips.map((trip) => trip.data.homeport);
  return new Set(homeports).size !== homeports.length;
};

export default homeportDups;
